<template>
  <div class="page_body" :class="{'page-bondo': isInBondo}">
      <div :class="{'bondo-login__bg': isInBondo}"></div>
      <div class="login-tab fc-clearfix">
        <!--登录的背景色-->
        <div class="login-tab-item" :class="{'active':loginType===0}" @click="loginType=0;isPhoneLogin=false;isEmailLogin=false;">
          <!--登录-->
          <div class="login-tab-title" :class="{'bondo-login': isInBondo }">{{$t('m.login')}}</div>
          <span class="line" v-if="isInBuzzCast"></span>
        </div>
        <div class="login-tab-item" :class="{'active':loginType===1}" @click="loginType=1" v-if="isInBuzzCast">
          <div class="login-tab-title">{{$t('m.scan_login')}}</div>
          <span class="line"></span>
        </div>
      </div>
      <!-- 三方登录 -->
    <div v-if="loginType===0">
      <login-phone v-if="isPhoneLogin" v-on:isEmailLogin="emailLogin" v-on:isPhoneLogin="phoneLogin" :thisLangcountry="thisLangcountry" />
      <login-email v-else-if="isEmailLogin" v-on:isEmailLogin="emailLogin" v-on:isPhoneLogin="phoneLogin" :thisLangcountry="thisLangcountry" />
      <login-sdk v-on:isEmailLogin="emailLogin" v-on:isPhoneLogin="phoneLogin" :thisLangcountry="thisLangcountry" v-else />
    </div>

      <!-- 扫码登录 -->
    <login-scan v-if="loginType===1 && isInBuzzCast" />

    <van-overlay class-name="fc_overlay" :show="$root.selOneAccount.show" z-index="100">
      <div class="login_box" @click.stop>
        <div class="login_header">
          <div class="fc-flex-1 fc-text-center">{{$t('m.sel_one_account')}}</div>
          <img src="../../assets/img/login_top_icon03.png" class="login_close" @click="$root.selOneAccount.show=false">
        </div>
        <div>
          <div class="sel_account_list" v-for="(item,index) in $root.selOneAccount.accountList" :key="'list'+index" @click="selAccount(index)">
            <div class="fc-flex fc-flex-vcenter">
              <img :src="item.logo" class="user_photo">
              <div>
                <div class="name">{{item.nickName}}</div>
                <div class="id">ID:{{item.userId}}</div>
              </div>
            </div>
            <van-icon class="checked_class" :class="{'fc-main-color':selAccountIndex==index}" name="checked" />
          </div>
          <div class="fc-text-center fc-pad-sm">
              <span class="confirm_sel_btn sel" v-if="selAccountIndex||selAccountIndex==0" @click="selThisLogin()">{{$t('m.sureBtn')}}</span>
              <span class="confirm_sel_btn" v-else>{{$t('m.sureBtn')}}</span>
          </div>
        </div>
      </div>
    </van-overlay>

  </div>
</template>
<script>
  import { myMixin } from "@/tools/mixins.js";
  import multiDomain from "../../mixins/multiDomain";
  import Vue from 'vue';
  import {
    Toast,Overlay,Icon
  } from 'vant';
  Vue.use(Toast);
  Vue.use(Overlay);
  Vue.use(Icon);

  import LoginScan from '@/components/Login/LoginScan';
  import LoginSdk from '@/components/Login/LoginSdk';

  import LoginPhone from '@/components/Login/LoginPhone';
  import LoginEmail from '@/components/Login/LoginEmail';

  export default {
    name: 'Login',
    mixins: [myMixin, multiDomain],
    components: {
      "login-scan": LoginScan,
      "login-sdk": LoginSdk,
      "login-phone": LoginPhone,
      "login-email": LoginEmail
    },
    data() {
      return {
        loginType:0,//登录类型 0 三方登录 1扫码登录
        isPhoneLogin:false, //是否手机登录
        isEmailLogin:false,//是否邮箱登录
        thisLangcountry:'en',
        selAccountIndex:null,
      }
    },
    filters: {

    },

    watch:{

    },
    mounted() {
      console.log(this.selOneAccount);
      //增加部分
      let userInfo = localStorage.getItem("userInfo");//缓存
      if(userInfo){
        this.$router.push({
          path: '/'
        })
      }
      //增加部分 end

      this.getLang();
      let language = this.getLang1();
      //console.log(language);
      if(language == 'zh-rHK'){
        this.thisLangcountry = 'en';//繁体按英文展示
      }else{
        this.thisLangcountry = language.substr(0, 2);
      }
      let localTab = localStorage.getItem('localTab');
      if(localTab=='scan'){
        this.loginType = 1;
        localStorage.setItem('localTab','');
      }
       let a = localStorage.getItem('selcountry');
      //console.log(a);
      if(a){
        //localStorage.setItem('selcountry','');
        this.isPhoneLogin = true;
      }
      let type = this.getParamsHash('type');
      if(type==='failed'){
        Toast('Auth Failed');
      }else if(type=='cancel'){
        Toast('Auth cancel');
      }
    },
    methods: {
      //选择账号
      selAccount(i){
        this.selAccountIndex=i;
      },
      selThisLogin(){
        let selLoginInfo=this.$root.selOneAccount.accountList[this.selAccountIndex];

        //Toast('登录成功');
        localStorage.setItem('userInfo', JSON.stringify(selLoginInfo));
        this.$router.push({
            name: 'index',
            params: { userInfo: selLoginInfo }
        })

        this.$root.selOneAccount.show=false;
      },






      phoneLogin(val){
       // console.log(val);
        this.isPhoneLogin = true;
        this.isEmailLogin = false;
      },
      emailLogin(val){
       // console.log(val);
        this.isEmailLogin = true;
        this.isPhoneLogin = false;
      },

      getLang() {
        var box = document.getElementById("app");
        let language = navigator.language || navigator.browserLanguage;
        if (language == 'ar') {
          box.style.direction = 'rtl';
        } else {
          box.style.direction = 'ltr';
        }
      },
    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fc_overlay{
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.login_box{
  width: 80%;
  max-width: 486px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;

}
.login_header{
  /* height: 55px; */
  padding: 10px;
  border-bottom: 1px solid #F3F3F3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding-left: 20px;
  padding-right: 20px; */
}
  .page_body{
    min-height: 100vh;
    background-color: #fff;
    overflow-x: hidden;
    position: relative;
  }
  .page-bondo {
    background: #17191A;
  }
  .bondo-login {
    color: #fff;
  }
  .bondo-login__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 3.67rem;
    height: 3.67rem;
    border-radius: 3.67rem;
    background: rgba(173, 255, 47, 0.24);
    filter: blur(1rem);
    transform: translate(-40%, -50%);
  }
  .ar .bondo-login__bg {
    left: unset !important;
    right: 0 !important;
    transform: translate(-140%, -50%) !important;
  }
  .login-tab{
    padding:.6rem .5rem 0;
  }
  .login-tab-item{
    float: left;
    margin-right: 0.46rem;
    text-align: center;
    /* height: .6rem; */
  }
  .login-tab-title{
    font-size: .3rem;
    /* height: .4rem; */
    line-height: .4rem;
    font-weight: bold;
  }
  .login-tab-item.active .login-tab-title{
    font-size: .44rem;
  }
  .line{
    display: inline-block;
    width: .3rem;
    height: .04rem;
    border-radius: .02rem;
    background-color: #fff;
    margin-bottom: .04rem;
  }
  .login-tab-item.active .line{
    background-color: #008AFF;
  }




.sel_account_list{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  margin: 0 10px;
  border-bottom: 1px solid #f2f2f2;
  /* font-size: 16px; */
}
.sel_account_list .id{
 color: #888;
}
.user_photo{
  width: 44px;
  height: 44px;
  overflow: hidden;
  border-radius: 50%;
  margin: 0 10px;
  flex: 0 0 44px;
}
.checked_class{
  font-size: 20px;
  color: #bbb;
  margin: 0 20px;
}
.confirm_sel_btn{
  min-width: 150px;
  max-width: 80%;
  display: inline-block;
	padding: 10px 20px;
	margin-left: auto;
	margin-right: auto;
	border-radius: 25px;
	text-align: center;
	color: #fff;
	background-color: #CDCDCD;
  cursor: pointer;

}
.confirm_sel_btn.sel{
  background-color: #008AFF;
}
.fc-main-color{
  color: #008AFF !important;
}




/* flex 布局 */
.fc-flex{display:flex;}
.fc-rows{display:flex; flex-direction:row;}
.fc-columns{display:flex; flex-direction:column;}
.fc-wrap{display:flex;  flex-direction:row; flex-wrap:wrap;}
.fc-nowrap{display:flex; flex-direction:row; flex-wrap:nowrap;}
.fc-space-between{display:flex; flex-direction:row; justify-content:space-between;}
.fc-flex-center{display:flex; flex-direction:row; justify-content:center;}
.fc-flex-end{display:flex; flex-direction:row; justify-content:flex-end;}
.fc-flex-vtop{align-items:flex-start;}
.fc-flex-vcenter{align-items:center;}
.fc-flex-vbottom{align-items:flex-end;}
.fc-no-scale{flex-shrink:0;}
.fc-flex1{flex:1;}










</style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue